import { useState, useEffect } from 'react';
import { useProtectedAction } from '../hooks/useProtectedAction';
import { useAuth } from '../context/AuthContext';
// Mesma instância/padrão que o resto do painel usa (services/firebase.js → migravip-e1afb)
import { db } from '../services/firebase';
import { doc, getDoc, setDoc } from 'firebase/firestore';

const PLANOS = [
  { nome: 'AVECGO / Até 2', mensal: 89.9,   anual: 77.9   },
  { nome: 'Até 2 Prof.',    mensal: 99.9,   anual: 88.9   },
  { nome: 'Até 5 Prof.',    mensal: 163.9,  anual: 122.9  },
  { nome: 'Até 10 Prof.',   mensal: 286.9,  anual: 224.9, popular: true },
  { nome: 'Até 20 Prof.',   mensal: 397.9,  anual: 272.9  },
  { nome: 'Até 30 Prof.',   mensal: 546.9,  anual: 409.9  },
  { nome: 'Até 40 Prof.',   mensal: 626.9,  anual: 489.9  },
  { nome: 'Até 50 Prof.',   mensal: 751.9,  anual: 559.9  },
  { nome: 'Ilimitado',      mensal: 1279.9, anual: 999.9  },
];

const ADDONS = [
  { tag: 'SaaS',   nome: 'Módulo Franquia',        desc: 'Para redes com múltiplas unidades.',       mensal: 218.9, anual: 190.9 },
  { tag: 'Fiscal', nome: 'NF de Serviço (NFS-e)',  desc: 'Emissão automática de nota fiscal.',        mensal: 114.9, anual: 104.9 },
  { tag: 'Fiscal', nome: 'NF de Produto',           desc: 'Nota fiscal de produto.',                  mensal: 114.9, anual: 104.9 },
  { tag: 'SMS',    nome: '1.000 SMS Avec',          desc: 'Pacote de disparos SMS.',                  mensal: 149.9, anual: 149.9 },
  { tag: 'SMS',    nome: '500 SMS Avec',            desc: 'Pacote de disparos SMS.',                  mensal: 79.9,  anual: 79.9  },
  { tag: 'Pay',    nome: 'White Label (manutenção)',desc: 'Até 10 unidades + R$50/unidade extra.',    mensal: 500,   anual: 500   },
];

const FAIXAS = [
  { l: 'Até 2',    ci: 75,  cs: 150, cm: 100, combo: 199  },
  { l: '3 a 5',    ci: 150, cs: 240, cm: 170, combo: 299  },
  { l: 'Até 10',   ci: 240, cs: 260, cm: 320, combo: 499  },
  { l: 'Até 20',   ci: 299, cs: 420, cm: 330, combo: 699  },
  { l: 'Até 30',   ci: 360, cs: 540, cm: 420, combo: 899  },
  { l: 'Até 40',   ci: 480, cs: 780, cm: 570, combo: 1299 },
  { l: 'Até 50',   ci: 540, cs: 899, cm: 660, combo: 1499 },
  { l: 'Ilimitado',ci: 599, cs: 720, cm: 1020,combo: 2000 },
];

const IA_MODS = [
  { ico: '🔔', nome: 'Confirmação (v01)',  desc: 'Confirmação automática via WhatsApp.',  key: 'ci' },
  { ico: '📅', nome: 'Agendamento (v02)',  desc: 'Agendamento inteligente com IA.',       key: 'cs' },
  { ico: '📣', nome: 'Marketing (v03)',    desc: 'Campanhas de marketing automatizadas.', key: 'cm' },
];

const fmt = (n) => 'R$ ' + Number(n).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

const TEMPLATE_PADRAO =
`Olá {nome} tudo bem? 👋

📋 *Proposta Avec*

*Plano:* {plano}

{itens}

💰 *Total: {total_mes}/mês*
{total_ano}

Qualquer dúvida é só me chamar! 🙌`;

// converte "10", "10,5", "" em número seguro
const num = (v) => {
  const n = parseFloat(String(v).replace(',', '.'));
  return isNaN(n) ? 0 : n;
};

// ─────────────────────────────────────────────────────────────
// Bloco de desconto por grupo.
// IMPORTANTE: fica FORA do componente. Se ficar dentro, o React
// remonta ele a cada render e o input perde o foco a cada tecla.
// ─────────────────────────────────────────────────────────────
const GrupoDesconto = ({ label, subtotal, mode, setMode, val, setVal }) => (
  <div style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '8px 0' }}>
    <div style={{ flex: 1, minWidth: 0 }}>
      <div style={{ fontSize: '12px', fontWeight: '600', color: '#0a0a18' }}>{label}</div>
      <div style={{ fontSize: '10px', color: '#9898b8' }}>Subtotal: {fmt(subtotal)}/mês</div>
    </div>
    <div style={{ display: 'flex', gap: '2px', background: '#f0f0f8', borderRadius: '8px', padding: '2px' }}>
      {['pct', 'brl'].map(m => (
        <button key={m} onClick={() => setMode(m)} style={{
          padding: '5px 10px', borderRadius: '6px', border: 'none', cursor: 'pointer',
          fontSize: '12px', fontWeight: '700',
          background: mode === m ? '#fff' : 'transparent',
          color: mode === m ? '#6c47ff' : '#9898b8',
          boxShadow: mode === m ? '0 1px 3px rgba(0,0,0,0.1)' : 'none'
        }}>{m === 'pct' ? '%' : 'R$'}</button>
      ))}
    </div>
    <input value={val} onChange={e => setVal(e.target.value)} placeholder="0"
      inputMode="decimal" style={{ ...inp, width: '80px', textAlign: 'right', padding: '8px 10px' }} />
  </div>
);

export default function Calculadora() {
  const { protect, Modals, logado } = useProtectedAction(false);
  const { user, contaUid } = useAuth();
  const [periodo, setPeriodo]   = useState('mensal');
  const [planoSel, setPlanoSel] = useState(null);
  const [addonsSel, setAddonsSel] = useState(new Set());
  const [faixaSel, setFaixaSel] = useState(null);
  const [iaSel, setIaSel]       = useState(new Set());
  const [copiado, setCopiado]   = useState(false);

  // Detalhar os módulos IA na proposta (mostra valor cheio de cada um + economia do combo)
  const [detalharIA, setDetalharIA] = useState(true);

  // Descontos por grupo — cada um com modo ('pct' | 'brl') e valor
  const [descPlatMode, setDescPlatMode] = useState('pct');
  const [descPlatVal,  setDescPlatVal]  = useState('');
  const [descProdMode, setDescProdMode] = useState('pct');
  const [descProdVal,  setDescProdVal]  = useState('');
  const [descIaMode,   setDescIaMode]   = useState('pct');
  const [descIaVal,    setDescIaVal]    = useState('');

  // Mensagem / template
  const [nomeCliente, setNomeCliente] = useState('');
  const [modoTemplate, setModoTemplate] = useState('padrao'); // 'padrao' | 'custom'
  const [templateCustom, setTemplateCustom] = useState(TEMPLATE_PADRAO);
  const [salvandoTpl, setSalvandoTpl] = useState(false);
  const [tplSalvo, setTplSalvo] = useState(false);
  const [tplErro, setTplErro] = useState('');

  // Carrega o template salvo do usuário (Firestore) ao logar
  useEffect(() => {
    if (!user || !contaUid) return;
    let vivo = true;
    (async () => {
      try {
        const snap = await getDoc(doc(db, 'config_proposta', contaUid));
        if (!vivo || !snap.exists()) return;
        const d = snap.data();
        if (d.template) setTemplateCustom(d.template);
        if (d.modo) setModoTemplate(d.modo);
        if (typeof d.detalharIA === 'boolean') setDetalharIA(d.detalharIA);
      } catch (e) {
        // silencioso: se falhar, usa o padrão
      }
    })();
    return () => { vivo = false; };
  }, [user, contaUid]);

  const salvarTemplate = async () => {
    if (!contaUid) { setTplErro('Entre para salvar seu modelo.'); return; }
    setSalvandoTpl(true); setTplErro('');
    try {
      await setDoc(doc(db, 'config_proposta', contaUid), {
        template: templateCustom,
        modo: modoTemplate,
        detalharIA,
        updatedAt: Date.now()
      }, { merge: true });
      setTplSalvo(true); setTimeout(() => setTplSalvo(false), 2000);
    } catch (e) {
      setTplErro('Erro ao salvar: ' + e.message);
    } finally {
      setSalvandoTpl(false);
    }
  };

  const toggleAddon = (i) => {
    setAddonsSel(prev => { const n = new Set(prev); n.has(i) ? n.delete(i) : n.add(i); return n; });
  };
  const toggleIA = (k) => {
    setIaSel(prev => { const n = new Set(prev); n.has(k) ? n.delete(k) : n.add(k); return n; });
  };

  const faixa   = faixaSel !== null ? FAIXAS[faixaSel] : null;
  const comboIA = iaSel.size === 3 && faixa;
  const plano   = planoSel !== null ? PLANOS[planoSel] : null;

  // ===== CÁLCULO (tudo mensal-equivalente; anual = mensal × 12) =====
  const precoPlano = plano ? (periodo === 'mensal' ? plano.mensal : plano.anual) : 0;

  const itensProdutos = [];
  let subProdutos = 0;
  addonsSel.forEach(i => {
    const a = ADDONS[i];
    const p = periodo === 'mensal' ? a.mensal : a.anual;
    subProdutos += p;
    itensProdutos.push({ nome: a.nome, desc: a.desc, preco: p });
  });

  // ===== MÓDULOS IA =====
  // Regra nova: os módulos SEMPRE aparecem itemizados com o preço cheio.
  // O combo deixa de ser "um item" e passa a ser uma LINHA DE DESCONTO.
  // Assim o cliente enxerga a âncora (ex: 820) e a vantagem (ex: -321 → 499).
  // O total final continua exatamente o mesmo de antes.
  const itensIA = [];
  let subIAcheio = 0;   // soma dos módulos a preço cheio
  let descComboIA = 0;  // desconto gerado pelo combo (cheio - combo)

  if (faixa) {
    if (comboIA && !detalharIA) {
      // modo compacto (comportamento antigo): uma linha só
      subIAcheio = faixa.combo;
      itensIA.push({ ico: '🤖', nome: 'Combo IA (3 módulos)', desc: 'Confirmação + Agendamento + Marketing.', preco: faixa.combo, badge: 'COMBO' });
    } else {
      // ordem estável (segue a ordem de IA_MODS, não a ordem de clique)
      IA_MODS.filter(m => iaSel.has(m.key)).forEach(m => {
        const p = faixa[m.key];
        subIAcheio += p;
        itensIA.push({ ico: m.ico, nome: m.nome, desc: m.desc, preco: p });
      });
      if (comboIA) descComboIA = Math.max(0, subIAcheio - faixa.combo);
    }
  }

  // base para o desconto manual de IA = valor já com o combo aplicado
  const subIA = subIAcheio - descComboIA;
  const subPlataforma = precoPlano;

  // valor do desconto de um grupo, respeitando o teto do subtotal
  const descontoValor = (subtotal, mode, val) => {
    const n = num(val);
    if (n <= 0 || subtotal <= 0) return 0;
    const d = mode === 'pct' ? subtotal * (n / 100) : n;
    return Math.min(d, subtotal);
  };
  const descLabel = (mode, val) => {
    const n = num(val);
    if (n <= 0) return '';
    return mode === 'pct' ? `(–${String(val).replace('.', ',')}%)` : `(–${fmt(n)})`;
  };

  const dPlat = descontoValor(subPlataforma, descPlatMode, descPlatVal);
  const dProd = descontoValor(subProdutos,  descProdMode, descProdVal);
  const dIA   = descontoValor(subIA,        descIaMode,   descIaVal);

  const totalCheio  = subPlataforma + subProdutos + subIAcheio;
  const totalDesc   = descComboIA + dPlat + dProd + dIA;
  const totalMensal = Math.max(0, totalCheio - totalDesc);
  const totalAnual  = totalMensal * 12;
  const economia    = totalDesc;

  // linhas para o resumo (painel da direita)
  const linhas = [];
  if (plano) linhas.push({ tipo: 'item', nome: plano.nome, preco: precoPlano });
  itensProdutos.forEach(x => linhas.push({ tipo: 'item', ...x }));
  itensIA.forEach(x => linhas.push({ tipo: 'item', ...x }));
  if (descComboIA > 0) linhas.push({ tipo: 'desc', nome: `Combo PROMO aplicado (3 módulos → ${fmt(faixa.combo)})`, valor: descComboIA, badge: 'COMBO' });
  if (dPlat > 0) linhas.push({ tipo: 'desc', nome: 'Desconto Plataforma ' + descLabel(descPlatMode, descPlatVal), valor: dPlat });
  if (dProd > 0) linhas.push({ tipo: 'desc', nome: 'Desconto Produtos ' + descLabel(descProdMode, descProdVal), valor: dProd });
  if (dIA   > 0) linhas.push({ tipo: 'desc', nome: 'Desconto IA ' + descLabel(descIaMode, descIaVal), valor: dIA });

  // ===== TEXTO WHATSAPP =====
  // Bloco {itens} agora vem agrupado, produto por produto, igual a versão antiga.
  const gerarItensTxt = () => {
    const L = [];

    if (plano) {
      L.push(`• *${plano.nome}*: ${fmt(precoPlano)}/mês`);
    }

    if (itensProdutos.length) {
      L.push('');
      L.push('*Módulos adicionais*');
      itensProdutos.forEach(x => L.push(`• ${x.nome}: ${fmt(x.preco)}/mês`));
    }

    if (itensIA.length) {
      L.push('');
      L.push('*Módulos IA*');
      itensIA.forEach(x => {
        L.push(`${x.ico} *${x.nome}*`);
        if (x.desc) L.push(x.desc);
        L.push(`${fmt(x.preco)}/mês`);
      });
      if (descComboIA > 0) {
        L.push('');
        L.push(`Subtotal: ${fmt(subIAcheio)}/mês`);
        L.push(`🎉 *Combo PROMO aplicado: ${fmt(faixa.combo)}/mês*`);
        L.push(`_Economia de ${fmt(descComboIA)}/mês_`);
      }
    }

    const manuais = [];
    if (dPlat > 0) manuais.push(`🏷️ Desconto Plataforma ${descLabel(descPlatMode, descPlatVal)}: -${fmt(dPlat)}/mês`);
    if (dProd > 0) manuais.push(`🏷️ Desconto Produtos ${descLabel(descProdMode, descProdVal)}: -${fmt(dProd)}/mês`);
    if (dIA   > 0) manuais.push(`🏷️ Desconto IA ${descLabel(descIaMode, descIaVal)}: -${fmt(dIA)}/mês`);
    if (manuais.length) {
      L.push('');
      manuais.forEach(m => L.push(m));
    }

    return L.join('\n').trim();
  };

  const gerarTexto = () => {
    if (!plano) return '';
    const modelo = modoTemplate === 'custom' ? templateCustom : TEMPLATE_PADRAO;
    const totalAno = periodo === 'anual' ? `📅 No plano anual: 12x = ${fmt(totalAnual)}/ano` : '';
    let txt = modelo
      .split('{nome}').join(nomeCliente.trim())
      .split('{plano}').join(plano.nome)
      .split('{itens}').join(gerarItensTxt())
      .split('{subtotal}').join(fmt(totalCheio))
      .split('{economia}').join(economia > 0 ? fmt(economia) : '')
      .split('{total_mes}').join(fmt(totalMensal))
      .split('{total_ano}').join(totalAno);
    txt = txt.replace(/[ \t]{2,}/g, ' ').replace(/\n{3,}/g, '\n\n');
    return txt.trim();
  };

  const copiar = () => {
    const txt = gerarTexto();
    if (!txt) return;
    navigator.clipboard.writeText(txt);
    setCopiado(true);
    setTimeout(() => setCopiado(false), 2000);
  };

  if (!logado) {
    return (
      <div style={{ maxWidth: '960px', margin: '0 auto' }}>
        {Modals}
        <div style={{ ...card, maxWidth: '420px', margin: '60px auto', textAlign: 'center' }}>
          <div style={{ fontSize: '34px', marginBottom: '12px' }}>{'\uD83D\uDD12'}</div>
          <h2 style={{ fontFamily: 'Syne, sans-serif', fontSize: '18px', fontWeight: '800', marginBottom: '8px' }}>Entre para usar a calculadora</h2>
          <p style={{ color: '#52526e', fontSize: '13px', marginBottom: '20px' }}>Faça login para montar propostas Avec.</p>
          <button onClick={protect(() => {})} style={{ background: 'linear-gradient(135deg, #6c47ff, #5535e0)', color: '#fff', border: 'none', borderRadius: '10px', padding: '11px 28px', fontSize: '14px', fontWeight: '600', cursor: 'pointer' }}>Entrar</button>
        </div>
      </div>
    );
  }

  const vars = ['{nome}', '{plano}', '{itens}', '{subtotal}', '{economia}', '{total_mes}', '{total_ano}'];

  return (
    <div style={{ maxWidth: '960px', margin: '0 auto' }}>

      <div style={{ marginBottom: '28px' }}>
        <h1 style={{ fontFamily: 'Syne, sans-serif', fontSize: '26px', fontWeight: '800', letterSpacing: '-0.5px', marginBottom: '6px' }}>
          Calculadora de Proposta
        </h1>
        <p style={{ color: '#52526e', fontSize: '13px' }}>
          Monte propostas Avec em segundos e copie direto para o WhatsApp.
        </p>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 300px', gap: '20px', alignItems: 'start' }}>

        {/* ESQUERDA */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>

          {/* 01 Periodicidade */}
          <div style={card}>
            <div style={secLabel}>{'01 — PERIODICIDADE'}</div>
            <div style={{ display: 'flex', gap: '4px', background: '#f0f0f8', borderRadius: '10px', padding: '3px', width: 'fit-content' }}>
              {['mensal', 'anual'].map(p => (
                <button key={p} onClick={() => setPeriodo(p)} style={{
                  padding: '7px 18px', borderRadius: '8px', border: 'none', fontSize: '13px', fontWeight: '600', cursor: 'pointer',
                  background: periodo === p ? '#fff' : 'transparent',
                  color: periodo === p ? '#6c47ff' : '#9898b8',
                  boxShadow: periodo === p ? '0 1px 4px rgba(0,0,0,0.1)' : 'none',
                  transition: 'all 0.2s'
                }}>
                  {p === 'mensal' ? 'Mensal' : 'Anual (12x)'}
                </button>
              ))}
            </div>
          </div>

          {/* 02 Plano */}
          <div style={card}>
            <div style={secLabel}>{'02 — PLANO AVEC (SaaS)'}</div>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: '8px' }}>
              {PLANOS.map((pl, i) => {
                const preco = periodo === 'mensal' ? pl.mensal : pl.anual;
                const sel = planoSel === i;
                return (
                  <button key={i} onClick={() => setPlanoSel(sel ? null : i)} style={{
                    padding: '12px 10px', borderRadius: '10px', cursor: 'pointer',
                    border: sel ? '2px solid #6c47ff' : '1.5px solid rgba(0,0,0,0.08)',
                    background: sel ? 'rgba(108,71,255,0.07)' : '#f8f8fc',
                    textAlign: 'center', position: 'relative', transition: 'all 0.15s'
                  }}>
                    {pl.popular && (
                      <div style={{ position: 'absolute', top: '-8px', right: '8px', background: '#6c47ff', color: '#fff', fontSize: '9px', fontWeight: '800', padding: '2px 7px', borderRadius: '6px' }}>TOP</div>
                    )}
                    <div style={{ fontSize: '11px', fontWeight: '700', color: sel ? '#6c47ff' : '#0a0a18', marginBottom: '4px' }}>{pl.nome}</div>
                    <div style={{ fontFamily: 'Syne, sans-serif', fontSize: '16px', fontWeight: '800', color: sel ? '#6c47ff' : '#0a0a18' }}>{fmt(preco)}</div>
                    <div style={{ fontSize: '10px', color: '#9898b8' }}>{periodo === 'mensal' ? '/mês' : '/mês (12x)'}</div>
                  </button>
                );
              })}
            </div>
          </div>

          {/* 03 Módulos SaaS */}
          <div style={card}>
            <div style={secLabel}>{'03 — MÓDULOS SaaS ADICIONAIS'}</div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
              {ADDONS.map((a, i) => {
                const sel = addonsSel.has(i);
                const preco = periodo === 'mensal' ? a.mensal : a.anual;
                return (
                  <div key={i} onClick={() => toggleAddon(i)} style={{
                    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                    padding: '10px 14px', borderRadius: '9px', cursor: 'pointer',
                    border: sel ? '1.5px solid #6c47ff' : '1.5px solid rgba(0,0,0,0.08)',
                    background: sel ? 'rgba(108,71,255,0.05)' : '#f8f8fc', transition: 'all 0.15s'
                  }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                      <div style={{ width: '24px', height: '24px', borderRadius: '6px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '10px', fontWeight: '700', background: sel ? '#6c47ff' : '#e5e7eb', color: sel ? '#fff' : '#52526e' }}>{a.tag.slice(0, 3)}</div>
                      <div>
                        <div style={{ fontSize: '12px', fontWeight: '600' }}>{a.nome}</div>
                        <div style={{ fontSize: '10px', color: '#9898b8' }}>{a.desc}</div>
                      </div>
                    </div>
                    <div style={{ fontSize: '12px', fontWeight: '700', color: sel ? '#6c47ff' : '#52526e', whiteSpace: 'nowrap' }}>{fmt(preco)}/mês</div>
                  </div>
                );
              })}
            </div>
          </div>

          {/* 04 Módulos IA */}
          <div style={card}>
            <div style={secLabel}>{'04 — MÓDULOS IA — CROSS-SELL'}</div>
            <div style={{ fontSize: '11px', fontWeight: '700', color: '#52526e', fontFamily: 'monospace', marginBottom: '8px' }}>FAIXA DE PROFISSIONAIS:</div>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px', marginBottom: '16px' }}>
              {FAIXAS.map((f, i) => (
                <button key={i} onClick={() => setFaixaSel(faixaSel === i ? null : i)} style={{
                  padding: '5px 12px', borderRadius: '8px', cursor: 'pointer', fontSize: '12px', fontWeight: '600', border: 'none',
                  background: faixaSel === i ? '#6c47ff' : '#f0f0f8', color: faixaSel === i ? '#fff' : '#52526e', transition: 'all 0.15s'
                }}>{f.l}</button>
              ))}
            </div>

            {faixa && (
              <>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                  {IA_MODS.map(m => {
                    const sel = iaSel.has(m.key);
                    const preco = faixa[m.key];
                    return (
                      <div key={m.key} onClick={() => toggleIA(m.key)} style={{
                        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                        padding: '10px 14px', borderRadius: '9px', cursor: 'pointer',
                        border: sel ? '1.5px solid #6c47ff' : '1.5px solid rgba(0,0,0,0.08)',
                        background: sel ? 'rgba(108,71,255,0.05)' : '#f8f8fc', transition: 'all 0.15s'
                      }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                          <span style={{ fontSize: '18px' }}>{m.ico}</span>
                          <div>
                            <div style={{ fontSize: '12px', fontWeight: '600' }}>{m.nome}</div>
                            <div style={{ fontSize: '10px', color: '#9898b8' }}>{m.desc}</div>
                          </div>
                        </div>
                        <div style={{ fontSize: '12px', fontWeight: '700', color: sel ? '#6c47ff' : '#52526e' }}>{fmt(preco)}/mês</div>
                      </div>
                    );
                  })}
                </div>

                {comboIA && (
                  <>
                    <div style={{ marginTop: '12px', background: 'rgba(22,163,74,0.07)', border: '1px solid rgba(22,163,74,0.2)', borderRadius: '9px', padding: '10px 14px', fontSize: '12px', color: '#16a34a' }}>
                      {'💡 Os 3 módulos juntos ativam o '}<strong>preço combo</strong>{`. Cheio: ${fmt(faixa.ci + faixa.cs + faixa.cm)} → Combo: ${fmt(faixa.combo)}/mês (economia de ${fmt(faixa.ci + faixa.cs + faixa.cm - faixa.combo)})`}
                    </div>

                    {/* Toggle: detalhar ou compactar o combo na proposta */}
                    <div
                      onClick={() => setDetalharIA(v => !v)}
                      style={{
                        marginTop: '10px', display: 'flex', alignItems: 'center', gap: '10px',
                        padding: '10px 14px', borderRadius: '9px', cursor: 'pointer',
                        border: '1.5px solid rgba(0,0,0,0.08)', background: '#f8f8fc'
                      }}>
                      <div style={{
                        width: '36px', height: '20px', borderRadius: '20px', flexShrink: 0,
                        background: detalharIA ? '#6c47ff' : '#d4d4e0', position: 'relative', transition: 'all 0.2s'
                      }}>
                        <div style={{
                          width: '16px', height: '16px', borderRadius: '50%', background: '#fff', position: 'absolute', top: '2px',
                          left: detalharIA ? '18px' : '2px', transition: 'all 0.2s', boxShadow: '0 1px 3px rgba(0,0,0,0.2)'
                        }} />
                      </div>
                      <div>
                        <div style={{ fontSize: '12px', fontWeight: '600', color: '#0a0a18' }}>Detalhar módulos na proposta</div>
                        <div style={{ fontSize: '10px', color: '#9898b8' }}>
                          {detalharIA
                            ? 'Mostra módulo por módulo + subtotal + combo aplicado (recomendado).'
                            : 'Mostra apenas uma linha: "Combo IA (3 módulos)".'}
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </>
            )}

            {!faixa && (
              <div style={{ textAlign: 'center', padding: '20px', color: '#9898b8', fontSize: '12px' }}>
                Selecione a faixa de profissionais acima para ver os preços
              </div>
            )}
          </div>

          {/* 05 Descontos */}
          <div style={card}>
            <div style={secLabel}>{'05 — DESCONTOS (POR GRUPO)'}</div>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <GrupoDesconto label="Plataforma (plano)" subtotal={subPlataforma} mode={descPlatMode} setMode={setDescPlatMode} val={descPlatVal} setVal={setDescPlatVal} />
              <div style={divisor} />
              <GrupoDesconto label="Produtos (módulos SaaS)" subtotal={subProdutos} mode={descProdMode} setMode={setDescProdMode} val={descProdVal} setVal={setDescProdVal} />
              <div style={divisor} />
              <GrupoDesconto label="IA (já com combo)" subtotal={subIA} mode={descIaMode} setMode={setDescIaMode} val={descIaVal} setVal={setDescIaVal} />
            </div>
            {totalDesc > 0 && (
              <div style={{ marginTop: '10px', fontSize: '12px', color: '#16a34a', fontWeight: '600' }}>
                Desconto total aplicado: –{fmt(totalDesc)}/mês
                {descComboIA > 0 && <span style={{ color: '#9898b8', fontWeight: '400' }}>{`  (inclui ${fmt(descComboIA)} do combo IA)`}</span>}
              </div>
            )}
          </div>

          {/* 06 Mensagem WhatsApp */}
          <div style={card}>
            <div style={secLabel}>{'06 — MENSAGEM DO WHATSAPP'}</div>

            <div style={{ marginBottom: '14px' }}>
              <label style={miniLbl}>Nome do cliente (opcional)</label>
              <input value={nomeCliente} onChange={e => setNomeCliente(e.target.value)} placeholder="Ex: Maria" style={inp} />
            </div>

            <div style={{ display: 'flex', gap: '4px', background: '#f0f0f8', borderRadius: '10px', padding: '3px', width: 'fit-content', marginBottom: '14px' }}>
              {[['padrao', 'Padrão'], ['custom', 'Personalizado']].map(([k, lb]) => (
                <button key={k} onClick={() => setModoTemplate(k)} style={{
                  padding: '7px 16px', borderRadius: '8px', border: 'none', fontSize: '13px', fontWeight: '600', cursor: 'pointer',
                  background: modoTemplate === k ? '#fff' : 'transparent',
                  color: modoTemplate === k ? '#6c47ff' : '#9898b8',
                  boxShadow: modoTemplate === k ? '0 1px 4px rgba(0,0,0,0.1)' : 'none'
                }}>{lb}</button>
              ))}
            </div>

            {modoTemplate === 'custom' && (
              <>
                <div style={{ fontSize: '11px', color: '#9898b8', marginBottom: '6px' }}>
                  Variáveis (clique pra inserir no fim):
                </div>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '5px', marginBottom: '8px' }}>
                  {vars.map(v => (
                    <button key={v} onClick={() => setTemplateCustom(t => t + v)} style={{
                      padding: '3px 8px', borderRadius: '6px', border: '1px solid rgba(108,71,255,0.3)',
                      background: 'rgba(108,71,255,0.06)', color: '#6c47ff', fontSize: '11px', fontFamily: 'monospace', cursor: 'pointer'
                    }}>{v}</button>
                  ))}
                </div>
                <textarea value={templateCustom} onChange={e => setTemplateCustom(e.target.value)} rows={10}
                  style={{ ...inp, fontFamily: 'monospace', fontSize: '12px', lineHeight: '1.5', resize: 'vertical' }} />
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginTop: '10px' }}>
                  <button onClick={salvarTemplate} disabled={salvandoTpl} style={{
                    background: tplSalvo ? '#16a34a' : 'linear-gradient(135deg, #6c47ff, #5535e0)', color: '#fff', border: 'none',
                    borderRadius: '9px', padding: '9px 18px', fontSize: '13px', fontWeight: '700', cursor: salvandoTpl ? 'wait' : 'pointer'
                  }}>{tplSalvo ? '✅ Salvo!' : salvandoTpl ? 'Salvando...' : '💾 Salvar meu modelo'}</button>
                  <button onClick={() => setTemplateCustom(TEMPLATE_PADRAO)} style={{
                    background: 'transparent', color: '#52526e', border: '1.5px solid rgba(0,0,0,0.1)',
                    borderRadius: '9px', padding: '9px 16px', fontSize: '13px', fontWeight: '600', cursor: 'pointer'
                  }}>↺ Restaurar padrão</button>
                  {tplErro && <span style={{ fontSize: '12px', color: '#dc2626' }}>{tplErro}</span>}
                </div>
              </>
            )}

            {/* Preview */}
            <div style={{ marginTop: '14px' }}>
              <div style={miniLbl}>Prévia da mensagem</div>
              <pre style={{
                whiteSpace: 'pre-wrap', wordBreak: 'break-word', fontFamily: 'DM Sans, sans-serif',
                fontSize: '12px', color: plano ? '#0a0a18' : '#9898b8', background: '#f8f8fc',
                border: '1px solid rgba(0,0,0,0.08)', borderRadius: '10px', padding: '14px', margin: 0
              }}>{plano ? gerarTexto() : 'Selecione um plano para gerar a prévia.'}</pre>
            </div>
          </div>
        </div>

        {/* DIREITA — PROPOSTA */}
        <div style={{ position: 'sticky', top: '20px' }}>
          <div style={{ ...card, background: '#0a0a18', border: 'none' }}>
            <div style={{ fontSize: '10px', fontWeight: '700', color: '#9898b8', letterSpacing: '1.5px', textTransform: 'uppercase', fontFamily: 'monospace', marginBottom: '16px' }}>
              {'📋 RESUMO DA PROPOSTA'}
            </div>

            {!plano ? (
              <div style={{ textAlign: 'center', padding: '32px 0', color: '#52526e', fontSize: '12px' }}>
                <div style={{ fontSize: '32px', marginBottom: '8px' }}>{'🧮'}</div>
                Selecione um plano<br />para começar
              </div>
            ) : (
              <>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', marginBottom: '16px' }}>
                  {linhas.map((l, i) => (
                    <div key={i} style={{
                      display: 'flex', justifyContent: 'space-between', gap: '8px', fontSize: '12px', padding: '8px 0',
                      borderBottom: i < linhas.length - 1 ? '1px solid rgba(255,255,255,0.07)' : 'none'
                    }}>
                      <span style={{ color: l.tipo === 'desc' ? '#4ade80' : '#9898b8' }}>
                        {l.badge && <span style={{ background: '#16a34a', color: '#fff', fontSize: '9px', padding: '1px 5px', borderRadius: '4px', marginRight: '5px', fontWeight: '700' }}>{l.badge}</span>}
                        {l.ico ? l.ico + ' ' : ''}{l.nome}
                      </span>
                      <span style={{ color: l.tipo === 'desc' ? '#4ade80' : '#fff', fontWeight: '600', whiteSpace: 'nowrap' }}>
                        {l.tipo === 'desc' ? '– ' + fmt(l.valor) : fmt(l.preco)}/mês
                      </span>
                    </div>
                  ))}
                </div>

                <div style={{ borderTop: '1px solid rgba(255,255,255,0.1)', paddingTop: '12px', marginBottom: '16px' }}>
                  {totalDesc > 0 && (
                    <>
                      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '6px', fontSize: '11px' }}>
                        <span style={{ color: '#52526e' }}>Subtotal</span>
                        <span style={{ color: '#9898b8', textDecoration: 'line-through' }}>{fmt(totalCheio)}/mês</span>
                      </div>
                      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '6px', fontSize: '11px' }}>
                        <span style={{ color: '#52526e' }}>Vantagem do cliente</span>
                        <span style={{ color: '#4ade80', fontWeight: '700' }}>– {fmt(economia)}/mês</span>
                      </div>
                    </>
                  )}
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <span style={{ color: '#9898b8', fontSize: '12px' }}>Total/mês</span>
                    <span style={{ fontFamily: 'Syne, sans-serif', fontSize: '22px', fontWeight: '800', color: '#fff' }}>{fmt(totalMensal)}</span>
                  </div>
                  {periodo === 'anual' && (
                    <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '4px', fontSize: '11px' }}>
                      <span style={{ color: '#9898b8' }}>Total anual (12x)</span>
                      <span style={{ color: '#6c47ff', fontWeight: '700' }}>{fmt(totalAnual)}</span>
                    </div>
                  )}
                </div>

                <button onClick={copiar} style={{
                  width: '100%', padding: '12px',
                  background: copiado ? '#16a34a' : 'linear-gradient(135deg, #6c47ff, #5535e0)',
                  color: '#fff', border: 'none', borderRadius: '10px', fontSize: '13px', fontWeight: '700', cursor: 'pointer', transition: 'all 0.2s'
                }}>
                  {copiado ? '✅ Copiado!' : '📋 Copiar para WhatsApp'}
                </button>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

const card = { background: '#fff', border: '1px solid rgba(0,0,0,0.08)', borderRadius: '14px', padding: '20px', boxShadow: '0 1px 3px rgba(0,0,0,0.05)' };
const secLabel = { fontSize: '9px', fontWeight: '700', letterSpacing: '2px', textTransform: 'uppercase', color: '#9898b8', marginBottom: '12px', fontFamily: 'monospace', display: 'flex', alignItems: 'center', gap: '8px' };
const inp = { width: '100%', padding: '10px 12px', borderRadius: '9px', border: '1.5px solid rgba(0,0,0,0.1)', fontSize: '14px', background: '#f8f8fc', outline: 'none', boxSizing: 'border-box', fontFamily: 'DM Sans, sans-serif', color: '#0a0a18' };
const miniLbl = { fontSize: '11px', fontWeight: '700', color: '#52526e', textTransform: 'uppercase', letterSpacing: '0.06em', fontFamily: 'monospace', display: 'block', marginBottom: '6px' };
const divisor = { height: '1px', background: 'rgba(0,0,0,0.06)' };
